import lockr from 'lockr';

const Lockr = {};

/**
 * Lockr wrapper plugin
 *
 * @param Vue
 * @param options
 */
Lockr.install = function(Vue, options)
{
    lockr.prefix = 'ONDURO_';
    
    let methods =
    {
        _getInstance()
        {
            return lockr;
        },
        
        //@TODO: Remove method
        prefix(prefix)
        {
            lockr.prefix = prefix;
        },
        
        set(key, value, prefix)
        {
            if (typeof prefix === 'string')
            {
                this.tmpPrefix(() => {
                    lockr.set(key, value);
                }, prefix)
            }
            else
            {
                lockr.set(key, value);
            }
        },
    
        get(key, prefix)
        {
            if (typeof prefix === 'string')
            {
                return this.tmpPrefix(() =>
                {
                    return lockr.get(key);
                }, prefix)
            }
            else return lockr.get(key);
        },
    
        getAll()
        {
            return lockr.getAll();
        },
        
        flush(prefix)
        {
            if (typeof prefix === 'string')
            {
                this.tmpPrefix(() =>
                {
                    lockr.flush();
                }, prefix);
            }
            else lockr.flush();
        },
    
        /**
         * remove key from store
         *
         * @param key
         * @param prefix
         */
        rm(key, prefix)
        {
            let _prefix = '';
            if (typeof prefix === 'string')
                _prefix = prefix;
            
            lockr.rm(`${_prefix}${key}`);
        },
    
        /**
         * Restore previous prefix after
         * assigning new, temporary prefix
         *
         * @param callback
         * @param prefix
         */
        tmpPrefix(callback, prefix)
        {
            let _prefix = lockr.prefix,
                _return;
            if (typeof callback === 'function')
            {
                lockr.prefix = prefix;
                _return = callback();
            }
            lockr.prefix = _prefix;
            
            return _return;
        }
    };

    // register global methods
    Vue.lockr = methods;

    // register instance methods
    Vue.prototype.$lockr = methods;
};

export default Lockr;



// WEBPACK FOOTER //
// ./src/js/plugins/localStore.js